(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sb-optical"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sb-optical')) {
  customElements.define('sb-optical', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.step = 0;
      this.variants=JSON.parse(this.dataset.variants||'[]');
      this.lensVariants=JSON.parse(this.dataset.lensVariants||'[]')||[];
      this.protectionVariants=JSON.parse(this.dataset.protectionVariants||'[]')||[];
      this.abort=new AbortController();
      this.q = s => this.querySelector(s);
      this.qa = s => [...this.querySelectorAll(s)];
      this.qa('select[data-field]').forEach(select => {
        const kind=select.dataset.field;
        const min=kind==='sph'?Number(this.dataset.sphMin)*4:kind==='cyl'?Number(this.dataset.cylMin)*4:0;
        const max=kind==='sph'?Number(this.dataset.sphMax)*4:kind==='cyl'?Number(this.dataset.cylMax)*4:180;
        for(let i=min;i<=max;i++){
          const value=kind==='axis'?String(i):((i>0?'+':'')+(i/4).toFixed(2));
          select.add(new Option(value,value));
        }
        if(kind==='axis'){select.disabled=true;select.required=false;}
      });
      this.variants.forEach(v=>this.q('[data-frame-variant]').add(new Option(v.title,String(v.id))));
      this.q('[data-frame-variant]').addEventListener('change',e=>{this.renderVariant(this.variants.find(v=>String(v.id)===e.target.value));this.updateSummary();this.form.elements.confirm.checked=false;});
      this.q('[data-open]').addEventListener('click',()=>this.open());
      document.addEventListener('click',e=>{
        const trigger=e.target.closest('[data-sb-rx-open]');
        if(trigger){e.preventDefault();this.open();}
      },{signal:this.abort.signal});
      this.qa('[data-step] h2').forEach((h,i)=>h.id=this.id+'-step-'+i);
      this.q('[data-remove-file]').addEventListener('click',()=>this.clearFile());
      this.form.elements.prescription_file.addEventListener('change',()=>this.readFile());
      this.dialog.addEventListener('close',()=>{if(!this.pdSuspended)this.clearFile();this.q('.sb-rx-entry').hidden=false;});
      this.q('[data-pd-open]')?.addEventListener('click',()=>this.openPd());
      this.q('[data-pd-resume]')?.addEventListener('click',()=>{if(this.pdComponent)this.pdComponent.setAttribute('open','false');this.resumePd();});
      this.q('[data-close]').addEventListener('click',()=>this.dialog.close());
      this.form.addEventListener('submit',e=>e.preventDefault());
      this.form.addEventListener('change',e=>{
        e.target.removeAttribute('aria-invalid');
        if(e.target.name!=='confirm')this.form.elements.confirm.checked=false;
        if(e.target.name==='method')this.setMethod();
        if(e.target.dataset.field==='cyl'){
          const axis=this.form.elements[e.target.name.replace('_cyl','_axis')];
          axis.disabled=e.target.value===''||Number(e.target.value)===0;
          axis.required=!axis.disabled;
          if(axis.disabled)axis.value='';
        }
        if(e.target.name==='dual'){
          const dual=e.target.checked;
          this.q('[data-single-pd]').hidden=dual;
          this.q('[data-dual-pd]').hidden=!dual;
          ['pd','pd_right','pd_left'].forEach(name=>{const input=this.form.elements[name];input.disabled=name==='pd'?dual:!dual;input.required=!input.disabled;});
        }
        this.updateSummary();
      });
      this.q('[data-next]').addEventListener('click',()=>{if(this.validate())this.show(this.step+1);});
      this.q('[data-back]').addEventListener('click',()=>this.show(this.step-1));
      this.q('[data-finish]').addEventListener('click',()=>this.addToCart());
      this.q('[data-reset]').addEventListener('click',()=>{
        this.form.reset();this.clearFile();this.setMethod();if(this.q('[data-pd-status]'))this.q('[data-pd-status]').hidden=true;
        this.qa('[data-field=axis]').forEach(s=>{s.disabled=true;s.required=false;});
        this.form.elements.dual.dispatchEvent(new Event('change',{bubbles:true}));
        this.qa('[aria-invalid]').forEach(e=>e.removeAttribute('aria-invalid'));
        this.show(0);
      });
    }
    openPd(){
      const component=document.querySelector('glasson-try-on');
      const status=this.q('[data-pd-status]');
      if(!component||!customElements.get('glasson-try-on')){status.textContent=this.dataset.pdUnavailable;status.hidden=false;return;}
      this.pdComponent=component;
      if(!this.pdBound){
        component.addEventListener('ok',event=>{
          if(!this.pdSuspended)return;
          const result=event.detail?.[0];
          if(!result||typeof result!=='object')return;
          const total=Number(result.pd),left=Number(result.leftPd),right=Number(result.rightPd);
          const f=this.form.elements;
          const valid=value=>Number.isFinite(value)&&value>=20&&value<=40;
          if(valid(left)&&valid(right)&&Number.isFinite(total)&&Math.abs(left+right-total)<=1){
            f.dual.checked=true;f.dual.dispatchEvent(new Event('change',{bubbles:true}));
            f.pd_left.value=String(left);f.pd_right.value=String(right);
          }else if(Number.isFinite(total)&&total>=40&&total<=80){
            f.dual.checked=false;f.dual.dispatchEvent(new Event('change',{bubbles:true}));f.pd.value=String(total);
          }else{status.textContent=this.dataset.pdInvalid;status.hidden=false;return;}
          f.confirm.checked=false;this.updateSummary();
          status.textContent=this.dataset.pdReceived;status.hidden=false;
        },{signal:this.abort.signal});
        this.pdObserver=new MutationObserver(()=>{if(this.pdSuspended&&component.getAttribute('open')!=='true')this.resumePd();});
        this.pdObserver.observe(component,{attributes:true,attributeFilter:['open']});
        this.pdBound=true;
      }
      this.pdSuspended=true;this.dialog.close();this.q('[data-pd-resume]').hidden=false;
      component.setAttribute('screen','measurement');component.setAttribute('has-measure','true');component.setAttribute('open','true');
    }
    resumePd(){
      if(!this.pdSuspended)return;
      this.pdSuspended=false;this.q('[data-pd-resume]').hidden=true;
      if(!this.dialog.open)this.dialog.showModal();
      this.show(0);this.q('[data-pd-open]')?.focus();
    }
    priceCents(raw){
      const value=String(raw??'0').trim().replace(',','.');
      if(!/^\d+(?:\.\d{1,2})?$/.test(value))return null;
      const [whole,fraction='']=value.split('.');
      const cents=Number(whole)*100+Number(fraction.padEnd(2,'0'));
      return Number.isSafeInteger(cents)?cents:null;
    }
    selectedLens(){
      const index=this.q('input[name="index"]:checked');
      const treatment=this.q('input[name="treatment"]:checked');
      const color=this.q('input[name="transition_color"]:checked');
      const colors={gray:'Grigio',green:'Verde',brown:'Marrone',blue:'Blu'};
      const shade=treatment?.dataset.transitions==='true'?colors[color?.value]:'Trasparente';
      return this.lensVariants.find(v=>v.option1===index?.dataset.lensOption&&v.option2===treatment?.dataset.lensOption&&v.option3===shade);
    }
    hasTransitions(){return this.q('input[name="treatment"]:checked')?.dataset.transitions==='true';}
    protectionPriceValue(input){
      if(this.hasTransitions()&&input?.dataset.transitionsPrice)return input.dataset.transitionsPrice;
      return input?.dataset.price;
    }
    selectedProtection(){
      const selected=this.q('input[name="protection"]:checked');
      if(!selected||selected.value==='none')return null;
      const option=this.hasTransitions()?selected.dataset.protectionTransitionsOption:selected.dataset.protectionOption;
      return this.protectionVariants.find(v=>v.option1===option);
    }
    updatePrices(){
      const preview=this.dataset.pricePreview==='true';
      const money=cents=>new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:preview?'EUR':this.dataset.currency||'EUR'}).format(cents/100);
      const variant=this.variants.find(v=>String(v.id)===this.q('[data-frame-variant]').value);
      const base=preview?this.priceCents(this.dataset.basePrice):0;
      const protectionInput=this.q('input[name="protection"]:checked');
      const protectionRequired=!!protectionInput&&protectionInput.value!=='none';
      const prices={frame:variant?.price||0,base};
      this.q('[data-base-price-row]').hidden=base===0;
      const protectionRow=this.q('[data-protection-price-row]');
      if(protectionRow)protectionRow.hidden=!protectionRequired;
      let valid=base!==null&&!!variant&&variant.available!==false;
      this.qa('input[data-price]').forEach(input=>{
        const cents=preview?this.priceCents(input.name==='protection'?this.protectionPriceValue(input):input.dataset.price):0;
        const target=input.closest('label').querySelector('[data-option-price]');
        target.textContent=cents===null?'—':cents===0?this.dataset.free:money(cents);
        target.classList.toggle('sb-rx-price-free',cents===0);
      });
      ['index','treatment','protection'].forEach(name=>{
        const selected=this.q('input[name="'+name+'"]:checked');
        prices[name]=selected?(preview?this.priceCents(name==='protection'?this.protectionPriceValue(selected):selected.dataset.price):0):0;
        if(prices[name]===null)valid=false;
      });
      Object.entries(prices).forEach(([key,value])=>{
        const target=this.q('[data-price-'+key+']');
        if(target)target.textContent=value===null?'—':value===0?this.dataset.free:money(value);
      });
      ['index','treatment','protection'].forEach(name=>{
        const target=this.q('[data-price-'+name+']');
        if(target&&!this.q('input[name="'+name+'"]:checked'))target.textContent='—';
      });
      const total=valid?(this.q('input[name="index"]:checked')?money(Object.values(prices).reduce((sum,value)=>sum+value,0)):'—'):'—';
      this.q('[data-price-total]').textContent=total;this.q('[data-price-mobile]').textContent=total;
      if(this.dataset.paidCheckout==='true'){
        const lens=this.selectedLens();
        const protectionVariant=this.selectedProtection();
        valid=valid&&!!lens&&lens.available!==false&&lens.price===prices.base+prices.index+prices.treatment;
        if(protectionRequired)valid=valid&&!!protectionVariant&&protectionVariant.available!==false&&protectionVariant.price===prices.protection;
      }
      this.q('[data-finish]').disabled=(preview&&this.dataset.paidCheckout!=='true')||!valid;
      this.priceValid=valid;
    }
    async addToCart(){
      if((this.dataset.pricePreview==='true'&&this.dataset.paidCheckout!=='true')||this.priceValid===false){const error=this.q('.sb-rx-cart-error');error.textContent=this.dataset.paidCheckout==='true'?this.dataset.linkError:this.dataset.previewOnly;error.hidden=false;return;}

      if(this.submitting)return;
      const invalid=[...this.form.querySelectorAll('input,select')].find(el=>!el.disabled&&!el.checkValidity());
      if(invalid){this.show(Number(invalid.closest('[data-step]').dataset.step));this.validate();return;}
      const error=this.q('.sb-rx-cart-error');error.hidden=true;
      const variant=this.variants.find(v=>String(v.id)===this.q('[data-frame-variant]').value);
      if(!variant||variant.available===false){error.textContent=this.dataset.linkError;error.hidden=false;return;}
      const paid=this.dataset.paidCheckout==='true';
      const lens=paid?this.selectedLens():null;
      const selectedProtection=this.selectedProtection();
      const protection=paid?selectedProtection:null;
      const formValues=Object.fromEntries(new FormData(this.form).entries());
      const selectedLabels=Object.fromEntries(['index','treatment','protection'].map(name=>{
        const input=this.q('input[name="'+name+'"]:checked');
        return [name,input?.nextElementSibling.firstChild.textContent.trim()||''];
      }));
      const colorInput=this.q('input[name="transition_color"]:checked');
      const transitionColor=colorInput&&!colorInput.disabled?colorInput.nextElementSibling.textContent.trim():'';
      const protectionInput=this.q('input[name="protection"]:checked');
      const protectionTitle=protectionInput&&protectionInput.value!=='none'?(selectedProtection?.title||selectedLabels.protection):'';
      this.submitting=true;
      const buttons=this.qa('button');buttons.forEach(b=>b.disabled=true);
      this.form.setAttribute('aria-busy','true');this.form.setAttribute('inert','');
      try{
        const root=window.Shopify?.routes?.root||'/';
        const cartResponse=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
        if(!cartResponse.ok)throw new Error(this.dataset.cartError);
        const cart=await cartResponse.json();
        if(!paid&&cart.item_count>0)throw new Error(this.dataset.cartNotEmpty);
        if(paid&&cart.items.some(item=>String(item.variant_id)===String(variant.id)))throw new Error(this.dataset.existingFrame);
        if(paid){
          if(!lens||lens.available===false)throw new Error(this.dataset.linkError);
          const currentResponse=await fetch(this.dataset.lensUrl+'.js',{headers:{Accept:'application/json'}});
          if(!currentResponse.ok)throw new Error(this.dataset.linkError);
          const current=await currentResponse.json();
          const fresh=current.variants.find(v=>String(v.id)===String(lens.id));
          if(!fresh||!fresh.available||fresh.price!==lens.price)throw new Error(this.dataset.linkError);
          if(protection){
            const protectionResponse=await fetch(this.dataset.protectionUrl+'.js',{headers:{Accept:'application/json'}});
            if(!protectionResponse.ok)throw new Error(this.dataset.linkError);
            const currentProtection=await protectionResponse.json();
            const freshProtection=currentProtection.variants.find(v=>String(v.id)===String(protection.id));
            if(!freshProtection||!freshProtection.available||freshProtection.price!==protection.price)throw new Error(this.dataset.linkError);
          }
        }
        const body=new FormData();
        const prefix=paid?'items[0]':'';
        body.append(paid?'items[0][id]':'id',String(variant.id));body.append(paid?'items[0][quantity]':'quantity','1');
        const prop=(key,value)=>body.append(paid?prefix+'[properties]['+key+']':'properties['+key+']',value);
        prop('Tipo ordine',paid?'ORDINE VISTA PERSONALIZZATO':'PROVA GRATUITA');
        prop('Montatura',this.dataset.product+' - '+variant.title);
        if(formValues.method==='manual'){
          prop('Prescrizione','Valori inseriti manualmente');
          for(const [eye,label] of [['right','OD'],['left','OS']]){
            prop(label+' - SPH',formValues[eye+'_sph']);prop(label+' - CYL',formValues[eye+'_cyl']);
            if(formValues[eye+'_axis']!==undefined)prop(label+' - Asse',formValues[eye+'_axis']);
          }
        }else{
          prop('Prescrizione','File allegato');
          prop('File prescrizione',formValues.prescription_file);
        }
        for(const [name,label] of [['pd','PD totale (mm)'],['pd_right','PD destra (mm)'],['pd_left','PD sinistra (mm)']])if(formValues[name]!==undefined)prop(label,formValues[name]);
        for(const [name,label] of [['index','Spessore'],['treatment','Trattamento']])prop(label,selectedLabels[name]);
        if(transitionColor)prop('Colore Transitions',transitionColor);
        if(protectionTitle)prop('Protezione lenti',protectionTitle);
        prop('Conferma','Dati di prescrizione e opzioni controllati dal cliente');
        if(paid){
          body.append('items[1][id]',String(lens.id));body.append('items[1][quantity]','1');body.append('items[1][parent_id]',String(variant.id));
          body.append('items[1][properties][Montatura]',this.dataset.product+' - '+variant.title);
          body.append('items[1][properties][Tipo ordine]','ORDINE VISTA PERSONALIZZATO');
          if(protection){
            body.append('items[2][id]',String(protection.id));body.append('items[2][quantity]','1');body.append('items[2][parent_id]',String(variant.id));
            body.append('items[2][properties][Montatura]',this.dataset.product+' - '+variant.title);
            body.append('items[2][properties][Protezione]',protection.title);
            body.append('items[2][properties][Tipo ordine]','ORDINE VISTA PERSONALIZZATO');
          }
        }
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body});
        if(!response.ok)throw new Error(this.dataset.cartError);
        window.location.assign(root+'cart');
      }catch(e){error.textContent=e.message||this.dataset.cartError;error.hidden=false;}
      finally{this.submitting=false;buttons.forEach(b=>b.disabled=false);this.form.removeAttribute('inert');this.updatePrices();this.form.removeAttribute('aria-busy');}
    }
    disconnectedCallback(){this.pdObserver?.disconnect();this.pdBound=false;this.abort?.abort();if(this.fileUrl)URL.revokeObjectURL(this.fileUrl);this.ready=false;}
    open(){
      const id=document.querySelector('form[id^="product-form-main-"] [name="id"]')?.value||new URL(location.href).searchParams.get('variant');
      const variant=this.variants.find(v=>String(v.id)===String(id))||this.variants[0];
      this.renderVariant(variant);
      if(!this.dialog.open)this.dialog.showModal();
      this.show(this.form.elements.method.value==='file'&&!this.form.elements.prescription_file.files.length?0:this.step);
    }
    renderVariant(variant){
      if(variant){
        this.q('[data-frame-variant]').value=String(variant.id);
        this.q('[data-variant-title]').textContent=variant.title;
        this.q('[data-frame-price]').textContent=variant.price===0?this.dataset.free:new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency||'EUR'}).format(variant.price/100);
        this.q('[data-frame-unavailable]').hidden=variant.available!==false;
        const image=this.q('.sb-rx-image');
        if(image&&variant.featured_image?.src){image.src=variant.featured_image.src;image.removeAttribute('srcset');image.alt=this.dataset.product+' — '+variant.title;}
      }
    }
    setMethod(){
      const file=this.form.elements.method.value==='file';
      this.q('[data-manual]').hidden=file;
      this.q('[data-file-panel]').hidden=!file;
      this.qa('[data-manual] select').forEach(el=>{el.disabled=file;el.required=!file;});
      if(!file)this.qa('[data-field=cyl]').forEach(el=>el.dispatchEvent(new Event('change',{bubbles:true})));
      this.form.elements.prescription_file.disabled=!file;
      this.form.elements.prescription_file.required=file;
      this.q('.sb-rx-error').hidden=true;
    }
    clearFile(){
      if(this.fileUrl)URL.revokeObjectURL(this.fileUrl);
      this.fileUrl=null;
      this.form.elements.prescription_file.value='';
      this.form.elements.prescription_file.setCustomValidity('');
      this.q('[data-file-name]').textContent='';
      this.q('[data-file-preview]').hidden=true;
      this.q('[data-file-preview]').removeAttribute('src');
      this.q('[data-remove-file]').hidden=true;
    }
    readFile(){
      const input=this.form.elements.prescription_file;
      if(this.fileUrl)URL.revokeObjectURL(this.fileUrl);
      this.fileUrl=null;
      this.q('[data-file-preview]').hidden=true;
      const file=input.files[0];
      const valid=file&&['image/jpeg','image/png','application/pdf'].includes(file.type)&&file.size>0&&file.size<=10*1024*1024;
      input.setCustomValidity(valid?'':this.dataset.fileError);
      this.q('[data-file-name]').textContent=valid?file.name:this.dataset.fileError;
      this.q('[data-remove-file]').hidden=!file;
      if(valid&&file.type.startsWith('image/')){this.fileUrl=URL.createObjectURL(file);this.q('[data-file-preview]').src=this.fileUrl;this.q('[data-file-preview]').hidden=false;}
    }
    validate(){
      const fields=[...this.q('[data-step="'+this.step+'"]').querySelectorAll('input,select')];
      const invalid=fields.filter(el=>!el.disabled&&!el.checkValidity());
      fields.forEach(el=>el.toggleAttribute('aria-invalid',invalid.includes(el)));
      invalid.forEach(el=>el.setAttribute('aria-invalid','true'));
      this.q('.sb-rx-error').hidden=invalid.length===0;
      if(invalid.length){invalid[0].focus();invalid[0].reportValidity();}
      return invalid.length===0;
    }
    show(step){
      this.step=Math.max(0,Math.min(3,step));
      const progress=Math.round((this.step+1)/4*100);
      this.q('.sb-rx-progress').setAttribute('aria-valuenow',String(progress));
      this.q('[data-progress-fill]').style.width=progress+'%';
      this.q('[data-progress-percent]').textContent=progress+'%';
      this.q('[data-progress-label]').textContent=this.step===3?this.dataset.progressReview:this.dataset.progressStep.replace('[step]',String(this.step+1));
      this.dialog.setAttribute('aria-labelledby',this.id+'-step-'+this.step);
      this.qa('[data-step]').forEach(el=>el.hidden=Number(el.dataset.step)!==this.step);
      this.q('.sb-rx-steps').hidden=this.step===3;
      this.qa('.sb-rx-steps li').forEach((el,i)=>{if(i===this.step)el.setAttribute('aria-current','step');else el.removeAttribute('aria-current');});
      this.q('[data-back]').hidden=this.step===0;
      this.q('[data-next]').hidden=this.step===3;
      this.q('[data-finish]').hidden=this.step!==3;
      this.q('[data-reset]').hidden=true;
      this.q('.sb-rx-success').hidden=true;
      this.q('.sb-rx-error').hidden=true;
      this.updateSummary();
      this.q('[data-step="'+this.step+'"] h2').focus();
      this.q('.sb-rx-body').scrollTop=0;
      if(window.matchMedia('(max-width:749px)').matches)this.q('.sb-rx-steps').scrollIntoView({block:'start'});
    }
    updateColors(){
      const index=this.q('input[name="index"]:checked');
      const treatment=this.q('input[name="treatment"]:checked');
      const active=treatment?.dataset.transitions==='true';
      const allowed=(index?.dataset.transitionColors||'').split(',').map(value=>value.trim());
      this.q('[data-transition-panel]').hidden=!active;
      this.qa('input[name="transition_color"]').forEach(input=>{
        const enabled=active&&allowed.includes(input.value);
        input.disabled=!enabled;input.required=enabled;input.closest('label').hidden=!enabled;
        if(!enabled){input.checked=false;input.removeAttribute('aria-invalid');}
      });
      const chosen=this.q('input[name="transition_color"]:checked');
      const summary=this.q('[data-summary-color]');summary.hidden=!active;
      summary.textContent=chosen?chosen.nextElementSibling.textContent:this.dataset.pending;
    }
    updateSummary(){
      this.updateColors();
      ['index','treatment'].forEach(name=>{
        const selected=this.q('input[name="'+name+'"]:checked');
        this.q('[data-summary-'+name+']').textContent=selected?selected.nextElementSibling.firstChild.textContent:this.dataset.pending;
      });
      const review=this.q('[data-review]');review.replaceChildren();
      if(this.form.elements.method.value==='file'){
        const files=document.createElement('dl');this.addRow(files,this.q('.sb-rx-method legend').textContent,this.form.elements.prescription_file.files[0]?.name||'—');review.append(files);
      }
      if(this.form.elements.method.value==='manual')this.qa('.sb-rx-eye').forEach(eye=>{
        const heading=document.createElement('h3');heading.textContent=eye.querySelector('legend').textContent;review.append(heading);
        const list=document.createElement('dl');
        eye.querySelectorAll('select').forEach(el=>this.addRow(list,el.closest('label').firstChild.textContent,el.disabled?this.dataset.noAxis:el.value));
        review.append(list);
      });
      const list=document.createElement('dl');
      ['pd','pd_right','pd_left'].forEach(name=>{const el=this.form.elements[name];if(!el.disabled)this.addRow(list,el.closest('label').firstChild.textContent,el.value);});
      ['index','treatment'].forEach(name=>{const el=this.q('input[name="'+name+'"]:checked');if(el)this.addRow(list,el.closest('fieldset').querySelector('legend').textContent,el.nextElementSibling.firstChild.textContent);});
      const protection=this.q('input[name="protection"]:checked');
      if(protection&&protection.value!=='none')this.addRow(list,this.q('.sb-rx-protection legend').textContent,protection.nextElementSibling.firstChild.textContent);
      const color=this.q('input[name="transition_color"]:checked');
      if(color&&!color.disabled)this.addRow(list,this.q('[data-transition-panel] legend').textContent,color.nextElementSibling.textContent);
      review.append(list);this.updatePrices();
    }
    addRow(list,key,value){const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=key;dd.textContent=value||'—';list.append(dt,dd);}
  });
}

  } catch(e) { console.error(e); }
})();
})();
